<template>
  <div class="helpCenter">
    <nav-header @getSearch = "getSearch" @getTelPhone = "getTelPhone"></nav-header>
    <cube-scroll
      ref="scroll"
      :data="items"
      :options="options"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp" class="page_scroll">
      <div class="noDataTip notice" v-if="helpList.length===0">
        <dl>
          <dt></dt>
          <dd>暂无数据</dd>
        </dl>
      </div>
      <div class="help-list">
        <ul class="help-ul">
            <li class="help-li" v-for="(item, index) in helpList" :key="index">
                <!-- <router-link :to="{name:'helpCenterDetail',params: {'helpId': item.help_id}}"> -->
              <router-link :to="{name:'helpCenterDetail',params: {'helpId': item.help_id}}">
                <div class="con">
                  <div class="pic" v-if="item.img">
                    <a  :href="item.video" class="js-video" >
                      <img v-lazy='item.img' alt="">
                      <span></span>
                    </a>
                  </div>
                  <div class="txt">
                    <h5><a href="javascript:;">{{item.title}}</a></h5>
                    <p>{{item.title1}}</p>
                  </div>
                  <!-- <em class="js-video" @click.prevent="lookvideo">{{item.video != '' ? '立即播放' : '立即查看'}}</em> -->
                </div>  
              </router-link>      
                <!-- <div class="help-list-look" v-show="item.classify ==2">
                    <div class="look-detail">
                        <h5>{{item.title}}</h5>
                        <p>{{item.text}}</p>
                    </div>
                    <div class="look-btn"><button>立即查看</button></div>
                </div> -->
            </li>
        </ul>
      </div>
    </cube-scroll>
    <!-- 视频弹窗 -->
                <!-- <div class="m-pop y-pop1 videoPop" v-show="videoPop">
                    <div class="pop-bg"></div>
                    <div class="inner">
                        <i class="i-close"></i>
                        <div class="m-video">
                            <video id="video1" width="100%" poster="" controls>
                                <source :src="video" type="video/mp4" codecs="avc1.42E01E,mp4a.40.2">
                                 <embed src="video/z.mp4" width="100%" autostart="false" /> -->
                            <!-- </video>
                        </div>
                    </div>
                </div> -->
  </div>
</template>
<script>
import navHeader from '../../components/nav/nav'
export default {
  name: 'helpCenter',
  data () {
    return {
      videoPop: false,
      video: '',
      items: [],
      options: {
        pullUpLoad: {
          threshold: 60,
          txt: {
            more: '加载更多',
            noMore: '没有更多了'
          }
        },
        pullDownRefresh: {
          threshold: 60,
          txt: '刷新成功'
        }
      },
      pageNum: 1,
      allpage: null,
      helpList: [],
      isSearch: false,
      searchText : ''
    }
  },
  mounted () {
    this.$loading.show()
    this.$share.WxInit('恩氏基因', '恩氏基因', '', '', '')
  },
  created (){
    let _this = this
    this.$nextTick(()=> {
      _this.getInit(1, 1)
      // _this.shareFriend('恩氏基因', '恩氏基因','')
    })
  },
  methods: {
    shareFriend (title,desc,imgIcon) {
      let _this = this
      // this.$wx.ready(function(){
      //   _this.$wx.updateTimelineShareData({
      //     title: title, // 分享标题
      //     desc: desc, // 分享描述
      //     link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //     imgUrl: imgIcon, // 分享图标
      //     success: function () {
      //       _this.$http.api.shareFriends({
      //         user_id: localStorage.getItem('user_id')
      //       }).then( result => {
      //       })
      //     }
      //   })
      // })
    },
    getInit (pageNum, type) {
      let _this = this
      this.isSearch = false
      this.$http.api.help({
        page : pageNum,
        size : 10,
        title: ''
      }).then(result => {
        this.$loading.hide()
        // this.helpList = result.rows
         _this.allpage = Math.ceil(result.total/10)
          let data = result.rows
          if (type == 1) {
            _this.helpList = [...data]
            _this.$refs.scroll.forceUpdate()
            _this.pageNum = 2
          } else {
            if (data.length > 0 && _this.pageNum <= _this.allpage) {
               _this.helpList = _this.helpList.concat(data)
              _this.pageNum = _this.pageNum + 1
              _this.$refs.scroll.forceUpdate()
            }
          }
      })
      if( _this.pageNum > _this.allpage){
          setTimeout(function () {
            _this.$refs.scroll.forceUpdate()
          }, 300)
      }
    },
    onPullingDown () {
      // this.isLoading = false
      if(this.isSearch){
        this.getSearch(this.searchText,1,1)
      }else {
        this.getInit(1, 1)
      }
      
    },
    onPullingUp () {
      let _this = this
      // _this.isLoading = false
      setTimeout(function () {
        if(_this.isSearch){
          _this.getSearch(this.searchText,_this.pageNum,2)
        }else {
          _this.getInit(_this.pageNum, 2)
        }
      }, 800)
    },
    getTelPhone() {
      // 点击电话弹窗
      this.$createDialog({
        type: 'confirm',
        // icon: 'cubeic-alert',
        title: '4006-878-036',
        // content: '我是内容',
        confirmBtn: {
          text: '通话',
          active: true,
          disabled: false,
          href: 'tel:4006-878-036'
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          // this.$createToast({
          //   type: 'warn',
          //   time: 1000,
          //   txt: '点击确认按钮'
          // }).show()
        },
        onCancel: () => {
          // this.$createToast({
          //   type: 'warn',
          //   time: 1000,
          //   txt: '点击取消按钮'
          // }).show()
        }
      }).show()
    },
    getSearch (value,pageNum = 1,type=1) {
      // console.log(value)
     this.isSearch = true
     this.searchText = value
     let _this = this
      this.$http.api.help({
        page : pageNum,
        size : 10,
        title: value
      }).then(result => {
        // this.helpList = result.rows
         _this.allpage = Math.ceil(result.total/10)
          let data = result.rows
          if (type == 1) {
            _this.helpList = [...data]
            _this.$refs.scroll.forceUpdate()
            _this.pageNum = 2
          } else {
            if (data.length > 0 && _this.pageNum <= _this.allpage) {
               _this.helpList = _this.helpList.concat(data)
              _this.pageNum = _this.pageNum + 1
              _this.$refs.scroll.forceUpdate()
            }
          }
      })
      if( _this.pageNum > _this.allpage){
          setTimeout(function () {
            _this.$refs.scroll.forceUpdate()
          }, 300)
      }
    },
    lookvideo(item) {
      this.videoPop = true
      this.video = item.video
    }
  },
  components: {
    navHeader
  }
}
</script>
<style lang="less" scoped>
.page_scroll{
  top: 61px;
}
.videoPop{
  display: block;
}
.noDataTip{
  width: 100%;
  text-align: center;
  padding-top: 30px;
}
.helpCenter{
  width: 100%;
  .help-list {
    width: 100%;
    padding: 15px 10px 0;
    box-sizing: border-box;
    .help-ul{
      width: 100%;
      .help-li{
        height: 68px;
        overflow: hidden;
        // padding: 7px 8px;
        box-sizing: border-box;
        background: #fff;
        position: relative;
        background:rgba(243,245,247,1);
        border-radius:10px;
        margin-bottom: 10px;
        .help-list-video{
          width: 100%;
          a{
            width: 56px;
            float: left;
            position: relative;
            img,video{
              width: 56px;
              height: 56px;
            }
            .video-icon{
              width: 20px;
              height: 23px;
              background: #dadada;
              position: absolute;
              top: 0;
              bottom: 0;
              right: 0;
              left: 0;
              margin: auto;
            }
          }
          .video-detail {
            width: 60%;
            margin: 0 auto;
            h5 {
              font-size:14px;
              font-family:MicrosoftYaHei;
              font-weight:400;
              color:rgba(51,51,51,1);
              margin-bottom: 4px;
            }
            p {
              height:25px;
              line-height: 14px;
              font-size:10px;
              font-family:MicrosoftYaHei;
              font-weight:400;
              color:rgba(102,102,102,1);
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin-bottom: 2px;
            }
            p::after {
                content: "...";
                font-weight: bold;
                position: absolute;
                bottom: 0;
                right: 0;
                padding: 0 20px 1px 45px;
            }
          }
          
        }
        .video-btn {
            position: absolute;
            bottom: 0;
            right: 0;
            button {
              padding: 2px 2px 2px 15px;
              font-size:11px;
              font-family:MicrosoftYaHei;
              font-weight:400;
              color:rgba(255,255,255,1);
              background: #8AAAED;
              outline: none;
              border:none;
            }
        }
        .help-list-look {
          width: 100%;
          height: 100%;
          .look-detail {
            width:80%;
            h5 {
              font-size:12px;
              font-family:MicrosoftYaHei;
              font-weight:400;
              color:rgba(51,51,51,1);
              margin-bottom: 4px;
            }
            p {
              height:25px;
              line-height: 12px;
              font-size:10px;
              font-family:MicrosoftYaHei;
              font-weight:400;
              color:rgba(102,102,102,1);
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin-bottom: 2px;
            }
            p::after {
                content: "...";
                font-weight: bold;
                position: absolute;
                bottom: 0;
                right: 0;
                padding: 0 20px 1px 45px;
                // background: url(http://css88.b0.upaiyun.com/css88/2014/09/ellipsis_bg.png) repeat-y;
            }
          }
          .look-btn {
            position: absolute;
            bottom: 0;
            right: 0;
            button {
              padding: 2px 2px 2px 15px;
              font-size:11px;
              font-family:MicrosoftYaHei;
              font-weight:400;
              color:rgba(255,255,255,1);
              background: #8AAAED;
              outline: none;
              border:none;
            }
          }
        }
      }
    }
  }
}
.help-li{background-color:#fff;padding-bottom:20px}
.help-li .con{overflow:hidden;padding:6px 7px;background-color:#f3f5f7;border-radius:5px;height:68px}
.help-li .pic{float:left;width:56px;height:56px;opacity:.8;margin-right:11px;position:relative}
.help-li .pic span{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:21px;height:24px;background:url(../../assets/images/yi4.png) center center no-repeat;-webkit-background-size:cover;background-size:cover}
.help-li img{display:block;width:100%;height:100%}
.help-li .txt{overflow:hidden;font-size:10px;line-height:1.5;color:#666;position:relative;padding-top:3px}
.help-li h5 a{font-size:12px;color:#333;font-weight:400;line-height:1.25;margin-bottom:4px;display:block;white-space:nowrap;overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis}
.help-li .txt p{display:-webkit-box;overflow:hidden;-webkit-line-clamp:2;-webkit-box-orient:vertical}
.help-li .con em{position:absolute;bottom:0;right:0;line-height:18px;height:18px;width:60px;text-align:right;padding:0 2px;font-size:11px;color:#fff;background:url(../../assets/images/yi3.png) center center no-repeat;-webkit-background-size:cover;background-size:cover;border-bottom-right-radius:5px}

</style>


